import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { track } from "./umami"
import { trackOnConnect } from "./track_on_connect"
import { firstViewInSession } from "./first_view_in_session"

// Base de tous les composants Strada (pont Hotwire Native) : émet
// `bridge_component_viewed` { component, identifier } la première fois que le
// composant est monté dans la session. `BridgeComponent.shouldLoad` n'est vrai
// que si le shell natif déclare le composant dans son user agent, donc rien
// n'est tracé dans un navigateur ni pour un composant que la version installée
// de l'app ignore.
//
// Une fois par session et par controller, pas par page : haptics et push_device
// sont montés sur chaque page du dashboard, un évènement par page vue
// triplerait le volume natif sans rien apprendre. `identifier` (nom Stimulus)
// distingue les controllers qui partagent un même pont (push_permission).
// `connect` est aussi rejoué par BridgeComponent.restore : la même garde le couvre.
//
// Un composant qui surcharge `connect` doit appeler `super.connect()` (déjà le
// cas pour le pont lui-même).
export default class TrackedBridgeComponent extends BridgeComponent {
  connect() {
    super.connect()
    trackOnConnect({
      element: this.element,
      fireOnConnect: true,
      fire: () => {
        if (!firstViewInSession(`bridge_component_viewed:${this.identifier}`)) return
        track("bridge_component_viewed", { component: this.component, identifier: this.identifier })
      }
    })
  }
}
